import Backbone from 'backbone'
import template from './text-widget-editor.hbs'
import Editor from 'scoreboard/components/rich-text/editor'
import getEditorTitle from './get-editor-title'
import FormView from 'scoreboard/components/form-view'
import _ from 'lodash'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import enums from 'scoreboard/components/enums'
import formHelper from 'scoreboard/components/form-helper'
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
import widgetMetadata from './widget-metadata'
const { TEXT } = FormWidgetType

const TextWidgetEditor = Backbone.View.extend({

	tagName: 'form',

	className: 'form-widget-editor has-custom-width text-widget-editor',

	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		formHelper.writeToDom(this.options.widget, this.el)

		let text = _.get(this.options, 'widget.html')
		this.editor = new Editor({ text })
		this.$('.editor-toolbar').after(this.editor.el)
		this.editor.render()

		this.listenToOnce(this.editor, 'load', function () {
			this.editor.focus()

			this.toolbar = this.editor.createToolbar()
			this.$('.editor-toolbar').append(this.toolbar.el)
			this.toolbar.render()

			this.listenTo(this.editor, 'change', () => this.formView.setDirty())
		}.bind(this))
		this.renderStateToggle()
		this.formView.start()
		return this
	},

	context: function() {
		return { title: getEditorTitle(this.options.widget) }
	},

	renderStateToggle: function() {
		let states = widgetMetadata.states[TEXT]
		this.stateToggle = new LabeledToggle({
			name: 'state',
			value: _.get(this.options.widget, 'state'),
			options: _.filter(enums.toOptionData('widgetState'), item => {
				if (_.includes(states, item.id)) {
					return _.extend(item, { value: item.id })
				}
			})
		})

		this.$('.labeled-toggle-container').append(this.stateToggle.el)
		this.stateToggle.render()
		this.stateToggle.on('change', () => {
			this.formView.change()
		})
	},

	submit: function() {
		let html = this.editor.val()
		let data = formHelper.readFromDom(this.el)
		let state = data.state
		this.trigger('done', { html, type: TEXT, state })
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.editor, this.formView, this.toolbar,
		this.stateToggle], 'remove')
	}
})

export default TextWidgetEditor
TextWidgetEditor.__filename__ = 'forms/widgets/text-widget-editor.js'
